module.exports = __webpack_public_path__ + "img/logo1 (34).5d25224c.jpg";